// Polyfill: Object.hasOwn 在部分微信小程序 WebView 中不支持
if (!(Object as any).hasOwn) {
  Object.defineProperty(Object, 'hasOwn', {
    value: function (obj: any, prop: PropertyKey) {
      return Object.prototype.hasOwnProperty.call(obj, prop);
    },
    configurable: true,
    enumerable: false,
    writable: true,
  });
}

import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
